import React, { useState } from 'react';
import { SubscriptionUpdatePaymentModal } from '@nexus/fff-payments';
import { useUserContext } from '@nexus/fff-utilities';
import { trackPageLoad } from '@nexus/fff-analytics';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import Disclaimer from './Disclaimer';
import MobileLayout from './MobileLayout';
import DesktopLayout from './DesktopLayout';
import Layout from '../../components/Layout';
// import HowItWorks from './HowItWorks';
import { Plans, MOBILE } from '../constants';
import styles from './subscribe-today.module.scss';
import MobileBg from './images/subscribe-today-bottom-bg@2x.png';
import useShowErrorOrRedirectThankYouPage from '../../hooks/useShowPayErrorOrThankYouPage';
import useScreenMode from '../../hooks/useScreenMode';
import useInviteContext from '../../hooks/useInviteContext';

export const SubscribeToday = ({ history, flags }) => {
  const screenMode = useScreenMode();
  const [selected, setSelected] = useState(Plans.ANNUAL);
  const homepageRedirect = () => {
    window.location.replace(process.env.REACT_APP_SITE_URL);
    return null;
  };
  const handleChange = (membership) => setSelected(membership);

  const { userInfo } = useUserContext();
  const isSocial = userInfo ? userInfo.user && userInfo.user.subscriptionType === 'SOCIAL' : false;

  if ((flags && flags.fffSocialFriendUpradeToFullMember !== true) || !isSocial) {
    homepageRedirect();
  } else {
    trackPageLoad({
      pathName: '/subscribe-today',
      properties: {
        role: (userInfo.user.role || '').toLowerCase(),
        subscription_state: (userInfo.user.subscriptionState || '').toLowerCase(),
      },
    }).then();
  }

  const { inviteInfo } = useInviteContext();
  const hostMemberName = inviteInfo && inviteInfo.senderName ? inviteInfo.senderName.trim().split(' ')[0] : '';

  const {
    showPayment,
    errorPaymentMessage,
    changeSubscription,
    onClose,
    isLoading,
  } = useShowErrorOrRedirectThankYouPage(history, '/reactivate-thanks', Plans.SOCIAL, []);

  const handleChangeSubscription = () => {
    changeSubscription(selected);
  };

  const purchaseStyle = screenMode === MOBILE
    ? { backgroundImage: `url(${MobileBg})`, backgroundPosition: 'center bottom', backgroundSize: 'cover' }
    : {};

  return (
    <Layout pageTitle="Subscribe Today" isLoading={isLoading}>
      <MobileLayout
        selectedPlan={selected}
        handlePlanChange={handleChange}
        hostMemberName={hostMemberName}
      />
      <DesktopLayout
        selectedPlan={selected}
        handlePlanChange={handleChange}
        hostMemberName={hostMemberName}
      />
      <section
        className={styles.purchase}
        style={purchaseStyle}
      >
        <Disclaimer />
        <button
          type="button"
          className={styles.confirm}
          onClick={handleChangeSubscription}
        >
          CONFIRM PURCHASE
        </button>
      </section>
      {/* <HowItWorks /> */}
      <SubscriptionUpdatePaymentModal
        onClose={onClose}
        subtitle={errorPaymentMessage}
        isOpen={showPayment}
        onSuccess={handleChangeSubscription}
        hasError={!!errorPaymentMessage}
      />
    </Layout>
  );
};

export default withLDConsumer()(SubscribeToday);
